import React, { useState, useEffect } from 'react';
import { Paper, Button } from '@material-ui/core';
import { Notifications } from '../../../shared';
import { goPuffApi as api } from '../../../api/goPuff';
import { MarkTmsStatusModal } from './markTmsStatusModal';
import { ViewTMSUploads } from './viewTMSUploads';

const GoPuffTMSUpload = () => {
    const [notification, setNotification] = useState({ text: '', level: '' });
    const [modalOpen, setModalOpen] = useState(false);
    const [row, setRow] = useState(null);
    const [status, setStatus] = useState('');
    const [action, setAction] = useState('');
    const [data, setData] = useState([]);
    const [bulkIDs, setBulkIDs] = useState([]);

    const getData = async () => {
        const res = await api.getTMSPalletUploads();
        if (res.status === false) {
            setNotification({ text: `No data found ${res.msg}`, level: 'error' });
            setData([]);
            return;
        }

        setData(res.data.rows);
    };

    useEffect(() => {
        getData();
    }, []);

    const onHandleButtonClick = (row, action, status) => {
        setModalOpen(true);
        setRow(row);
        setAction(action);
        setStatus(status);
    };

    const columns = [
        { accessor: 'loadNumber', Header: 'Load Number' },
        { accessor: 'shipDate', Header: 'Ship Date' },
        { accessor: 'deliverToSiteDate', Header: 'Deliver To Site' },
        { accessor: 'purchaseOrderNumber', Header: 'PO Number' },
        { accessor: 'carrier', Header: 'Carrier' },
        { accessor: 'pallets', Header: 'Estimated Pallets' },
        {
            accessor: 'actualPallets',
            Header: 'Actual Pallets',
            editable: true,
            editProps: {
                type: 'input',
                inputType: 'number',
            },
        },
        { accessor: 'weight', Header: 'Total Weight' },
        { accessor: 'pieces', Header: 'Pieces' },
        { accessor: 'goPuffSiteID', Header: 'GoPuff Site ID' },
        { accessor: 'locationName', Header: 'Location Name' },
        { accessor: 'deliveryState', Header: 'Delivery State' },
        { accessor: 'status', Header: 'Status' },
        {
            accessor: 'arrivedButton',
            Header: 'Mark Arrived At Origin',
            Cell: ({ row }) => (
                <Button onClick={() => onHandleButtonClick(row, 'ArrivedAtOrigin', 'Arrived')}>Arrived</Button>
            ),
        },
        {
            accessor: 'inRouteButton',
            Header: 'Mark En Route',
            Cell: ({ row }) => (
                <Button onClick={() => onHandleButtonClick(row, 'InTransit', 'En Route')}>En Route</Button>
            ),
        },
        {
            accessor: 'deliveredButton',
            Header: 'Mark Completed Shipment',
            Cell: ({ row }) => (
                <Button onClick={() => onHandleButtonClick(row, 'Delivered', 'Delivered')}>Delivered</Button>
            ),
        },
    ];

    return (
        <div>
            {modalOpen && (
                <MarkTmsStatusModal
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    row={row}
                    action={action}
                    status={status}
                    setNotification={setNotification}
                    getData={getData}
                    bulkIDs={bulkIDs}
                    setBulkIDs={setBulkIDs}
                    setAction={setAction}
                />
            )}
            <Notifications options={notification} />
            <Paper>
                <ViewTMSUploads
                    data={data}
                    setNotification={setNotification}
                    columns={columns}
                    setBulkIDs={setBulkIDs}
                    setModalOpen={setModalOpen}
                    getData={getData}
                />
            </Paper>
        </div>
    );
};

export { GoPuffTMSUpload };
